import React from "react";
import { CardContent, CardHeader, IconButton } from "@material-ui/core";
import { ArrowBack, ArrowBackIos } from "@material-ui/icons";
import { Container } from "./styles";
import { useContacts } from "../../../contexts";

export default function ItemSpotlight({
  leftAction,
  title,
  children,
  ...props
}) {
  const { setSpotlight } = useContacts();

  function action() {
    return (
      <div className="header" onClick={() => setSpotlight(null)}>
        <ArrowBackIos style={{ marginRight: 8 }} />
        {leftAction}
      </div>
    );
  }

  return (
    <Container>
      <CardHeader avatar={action()} title={title} />

      <CardContent style={{ paddingTop: 20 }}>{children}</CardContent>
    </Container>
  );
}
